export class infoSaldoModel {
    public noRekening: string
    public noAlternatif: String
    public namaPemilik: string
    public saldo: number
    public enabledOy: boolean
    public enabledSbi: boolean
    public enabledMakara: boolean
    public va: Array<any>

    constructor(data: infoSaldoModel = null) {
        if (data != null) {
            this.noRekening = data.noRekening
            this.noAlternatif = data.noAlternatif
            this.saldo = data.saldo
            this.namaPemilik = data.namaPemilik
            this.enabledOy = data.enabledOy
            this.enabledSbi = data.enabledSbi
            this.enabledMakara = data.enabledMakara
            this.va = data.va
        }
    }
}

export class infoAccountModel {
    public noRekening: string
    public namaPemilik: string
    public namaIbu: string
    public alamat: string
    public ttl: string
    public saldo: number
    public jenisRekening: string
    public pinSet: boolean
    public enabledOy: boolean
    public enabledSbi: boolean
    public enabledMakara: boolean
    public va: Array<any>
    public billsInfo: object

    constructor(data: infoAccountModel = null) {
        if (data != null) {
            this.noRekening = data.noRekening
            this.namaPemilik = data.namaPemilik
            this.namaIbu = data.namaIbu
            this.alamat = data.alamat
            this.ttl = data.ttl
            this.saldo = data.saldo
            this.jenisRekening = data.jenisRekening
            this.pinSet = data.pinSet
            this.enabledOy = data.enabledOy
            this.enabledSbi = data.enabledSbi
            this.enabledMakara = data.enabledMakara
            this.va = data.va
            this.billsInfo = data.billsInfo
        }
    }
}

export class infoHistoryModel {
    public debet: number
    public kredit: number
    public saldo: number
    public historyItem: Array<infoHistoryItemModel>
    public provider: string

    constructor(data: infoHistoryModel = null) {
        if (data != null) {
            this.debet = data.debet
            this.kredit = data.kredit
            this.saldo = data.saldo
            this.historyItem = data.historyItem
            this.provider = data.provider
        }
    }
}

export class infoHistoryItemModel {
    public codeDate: string
    public nominal: number
    public keterangan: string

    constructor(data: infoHistoryItemModel = null) {
        if (data != null) {
            this.codeDate = data.codeDate
            this.nominal = data.nominal
            this.keterangan = data.keterangan
        }
    }
}

export class infoIuranModel {
    public tagihan: number
    public iuran: number
    public tunggakan: number
    public jangkaWaktu: number
    public periodeBerjalan: number
    public keterangan: string
    public accNumber: string
    public kodeGroup1: string
    public kodeGroup2: string
    public kodeGroup3: string
    public kodeGroup4: string
    public kodeGroup1Desc: string
    public kodeGroup2Desc: string
    public kodeGroup3Desc: string
    public kodeGroup4Desc: string
    public paymentVa: any

    constructor(data: infoIuranModel = null) {
        if (data != null) {
            this.tagihan = data.tagihan
            this.iuran = data.iuran
            this.tunggakan = data.tunggakan
            this.jangkaWaktu = data.jangkaWaktu
            this.periodeBerjalan = data.periodeBerjalan
            this.keterangan = data.keterangan
            this.accNumber = data.accNumber
            this.kodeGroup1 = data.kodeGroup1
            this.kodeGroup2 = data.kodeGroup2
            this.kodeGroup3 = data.kodeGroup3
            this.kodeGroup4 = data.kodeGroup4
            this.kodeGroup1Desc = data.kodeGroup1Desc
            this.kodeGroup2Desc = data.kodeGroup2Desc
            this.kodeGroup3Desc = data.kodeGroup3Desc
            this.kodeGroup4Desc = data.kodeGroup4Desc
            this.paymentVa = data.paymentVa
        }
    }
}


// WEBPACK FOOTER //
// ./src/model/financeModel.ts